import { useEffect, useRef } from 'react'
import { useMapPanelResize } from './useMapPanelResize'

/**
 * useHomePageMapEffects - Small cross-cutting effects for HomePageMap:
 * panel-state sync, map resize on panel width transitions, and one-shot
 * onboarding intent consumption.
 * @atomic
 */
export function useHomePageMapEffects({
  isImmersiveMode,
  panelState,
  isSearchPanelMinimized,
  setIsSearchPanelMinimized,
  mapRef,
  initialIntent,
  handleCurrentLocation
}) {
  // Sync panelState from useImmersiveTabs with internal isSearchPanelMinimized state
  useEffect(() => {
    if (isImmersiveMode) {
      const shouldBeMinimized = panelState === 'minimized'
      if (isSearchPanelMinimized !== shouldBeMinimized) {
        setIsSearchPanelMinimized(shouldBeMinimized)
      }
    }
  }, [panelState, isImmersiveMode, isSearchPanelMinimized, setIsSearchPanelMinimized])

  useMapPanelResize({ isImmersiveMode, panelState, mapRef })

  // Consume intent from onboarding modal once map state is ready (one-shot)
  const intentAppliedRef = useRef(false)
  useEffect(() => {
    if (!initialIntent || intentAppliedRef.current) return
    if (initialIntent === 'track_vendors') {
      intentAppliedRef.current = true
      // Pass a no-op for onPanelMinimize to prevent the GPS side-effect of collapsing the panel
      const timer = setTimeout(() => handleCurrentLocation(() => {}), 400)
      return () => clearTimeout(timer)
    }
  }, [initialIntent, handleCurrentLocation])
}
